import { AxiosInstance } from 'axios';
import { LoginFormParams } from './AuthQueries';

export default class AuthService {
  constructor(private axios: AxiosInstance) {}

  login = async (params: LoginFormParams): Promise<string> => {
    const { data } = await this.axios.post('auth/login', params);
    return data;
  };
}
